"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockfileParser = void 0;
const lockfile_parser_1 = require("./lockfile-parser");
exports.LockfileParser = lockfile_parser_1.default;
//# sourceMappingURL=index.js.map